import "./FFLIX.1a85781d.js";
import "./FFLIX.8b398cc7.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8b54"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8b54"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// Firebase imports

var $fhN3L = parcelRequire("fhN3L");

var $6AR8M = parcelRequire("6AR8M");

var $ilpIi = parcelRequire("ilpIi");



// FIREBASE CONFIG | VALUES FROM .env FILE
const $35da740d59af89ba$var$firebaseConfig = {
    apiKey: "AIzaSyDHorGZVXbSvbIt0QyyfQJU3Q-BIrE6SyA",
    authDomain: "first-projects-8226e.firebaseapp.com",
    projectId: "first-projects-8226e",
    storageBucket: "first-projects-8226e.firebasestorage.app",
    messagingSenderId: "537006742741",
    appId: "1:537006742741:web:3a71866ca7a84a5f116d65c"
};
// safety check to ensure variables are actually loading from .env
if (!$35da740d59af89ba$var$firebaseConfig.apiKey) console.error("CRITICAL ERROR: Firebase API Key is missing. Check your .env file!");
const $35da740d59af89ba$var$app = (0, $fhN3L.initializeApp)($35da740d59af89ba$var$firebaseConfig);
const $35da740d59af89ba$var$auth = (0, $6AR8M.getAuth)($35da740d59af89ba$var$app);
const $35da740d59af89ba$var$provider = new (0, $6AR8M.GoogleAuthProvider)();
const $35da740d59af89ba$var$db = (0, $ilpIi.getFirestore)($35da740d59af89ba$var$app);
// GLOBAL CONSTANTS
let $35da740d59af89ba$var$GAME_DATA = {}; // Holds all games indexed by ID
let $35da740d59af89ba$var$FEATURED_LIST = []; // Holds games/slides for the top banner
let $35da740d59af89ba$var$ROW_BUCKETS = {}; // Groups games by category (New, Brand, etc.)
let $35da740d59af89ba$var$rotatorInterval = null; // Reference to the 8-second timer
//UI CONSTANTS
const $35da740d59af89ba$var$STATIC_IMAGE_FALLBACK_PATH = (0, {});
const $35da740d59af89ba$var$RESTRICTED_BRANDS = [
    "Novomatic",
    "Penguin King"
];
// UI ELEMENTS
let $35da740d59af89ba$var$bodyEl, $35da740d59af89ba$var$viewLoggedOut, $35da740d59af89ba$var$viewLoggedIn, $35da740d59af89ba$var$emailInputEl, $35da740d59af89ba$var$passwordInputEl;
let $35da740d59af89ba$var$featuredContainer, $35da740d59af89ba$var$featuredBtn, $35da740d59af89ba$var$featuredLogo, $35da740d59af89ba$var$featuredDesc, $35da740d59af89ba$var$featuredRtp, $35da740d59af89ba$var$featuredBgLayer;
let $35da740d59af89ba$var$detailsModal, $35da740d59af89ba$var$detailsName, $35da740d59af89ba$var$detailsBg, $35da740d59af89ba$var$detailsLogo, $35da740d59af89ba$var$detailsBtn, $35da740d59af89ba$var$detailsMoreInfoBtn;
let $35da740d59af89ba$var$detailsDesc, $35da740d59af89ba$var$detailsRtp, $35da740d59af89ba$var$detailsBrand, $35da740d59af89ba$var$detailsFeatures, $35da740d59af89ba$var$closeDetailsBtn;
let $35da740d59af89ba$var$categoryModal, $35da740d59af89ba$var$closeCategoryBtn, $35da740d59af89ba$var$modalTitle, $35da740d59af89ba$var$modalGrid;
let $35da740d59af89ba$var$searchInput, $35da740d59af89ba$var$searchExpandable, $35da740d59af89ba$var$suggestionsContainer, $35da740d59af89ba$var$searchResultsContainer, $35da740d59af89ba$var$searchResultsItems, $35da740d59af89ba$var$searchResultsTitle;
let $35da740d59af89ba$var$filterSidebar, $35da740d59af89ba$var$brandFiltersContainer, $35da740d59af89ba$var$featureFiltersContainer, $35da740d59af89ba$var$applyFiltersBtn, $35da740d59af89ba$var$clearFiltersBtn, $35da740d59af89ba$var$closeFilterBtn;
let $35da740d59af89ba$var$currentFilters = {
    brands: [],
    features: []
};
let $35da740d59af89ba$var$calendarBtn, $35da740d59af89ba$var$calendarView, $35da740d59af89ba$var$calendarContent, $35da740d59af89ba$var$homeViewContainer, $35da740d59af89ba$var$calendarHomeLink;
// ===== AUTHENTICATION HANDLERS =====
function $35da740d59af89ba$var$clearAuthFields() {
    if ($35da740d59af89ba$var$emailInputEl) $35da740d59af89ba$var$emailInputEl.value = "";
    if ($35da740d59af89ba$var$passwordInputEl) $35da740d59af89ba$var$passwordInputEl.value = "";
}
function $35da740d59af89ba$var$authSignInWithGoogle(e) {
    if (e) e.preventDefault();
    (0, $6AR8M.signInWithPopup)($35da740d59af89ba$var$auth, $35da740d59af89ba$var$provider).then(()=>console.log("Google Auth Success")).catch((err)=>console.error("Google Auth Error:", err.message));
}
function $35da740d59af89ba$var$authSignInWithEmail(e) {
    if (e) e.preventDefault();
    const email = $35da740d59af89ba$var$emailInputEl?.value;
    const password = $35da740d59af89ba$var$passwordInputEl?.value;
    if (!email || !password) return;
    (0, $6AR8M.signInWithEmailAndPassword)($35da740d59af89ba$var$auth, email, password) // Function from firebase import
    .then(()=>$35da740d59af89ba$var$clearAuthFields()).catch((err)=>console.error("Sign In Error:", err.message));
}
function $35da740d59af89ba$var$authCreateAccountWithEmail(e) {
    if (e) e.preventDefault();
    const email = $35da740d59af89ba$var$emailInputEl?.value;
    const password = $35da740d59af89ba$var$passwordInputEl?.value;
    if (!email || !password) return;
    (0, $6AR8M.createUserWithEmailAndPassword)($35da740d59af89ba$var$auth, email, password) // Function from firebase imports
    .then(()=>$35da740d59af89ba$var$clearAuthFields()).catch((err)=>console.error("Account Creation Error:", err.message));
}
function $35da740d59af89ba$var$authSignOut(e) {
    if (e) e.preventDefault();
    if ($35da740d59af89ba$var$rotatorInterval) clearInterval($35da740d59af89ba$var$rotatorInterval); // stop 8-second rotation timer so memory isn't wasted
    (0, $6AR8M.signOut)($35da740d59af89ba$var$auth).catch((err)=>console.error("Sign Out Error:", err.message));
}
function $35da740d59af89ba$var$showLoggedInView() {
    if ($35da740d59af89ba$var$viewLoggedOut) $35da740d59af89ba$var$viewLoggedOut.style.display = "none";
    if ($35da740d59af89ba$var$viewLoggedIn) $35da740d59af89ba$var$viewLoggedIn.style.display = "flex";
}
function $35da740d59af89ba$var$showLoggedOutView() {
    if ($35da740d59af89ba$var$viewLoggedOut) $35da740d59af89ba$var$viewLoggedOut.style.display = "flex";
    if ($35da740d59af89ba$var$viewLoggedIn) $35da740d59af89ba$var$viewLoggedIn.style.display = "none";
}
// ===== UTILITY & HELPERS =====
// When using searchbar, waits for user to stop typing before searching firebase (saves searching after each input letter)
function $35da740d59af89ba$var$debounce(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(()=>func.apply(context, args), wait);
    };
}
// Makes rows scrollable (horizontally)
function $35da740d59af89ba$var$setupRowInteractions(rowWrapper) {
    if (!rowWrapper) return;
    const leftBtn = rowWrapper.querySelector('.scroll-btn.left');
    const rightBtn = rowWrapper.querySelector('.scroll-btn.right');
    const itemsContainer = rowWrapper.querySelector('.row-items');
    if (!leftBtn || !rightBtn || !itemsContainer) return;
    const checkScroll = ()=>{
        const tolerance = 5;
        const maxScroll = itemsContainer.scrollWidth - itemsContainer.clientWidth;
        const currentScroll = itemsContainer.scrollLeft;
        if (itemsContainer.scrollWidth <= itemsContainer.clientWidth) {
            leftBtn.classList.add('hidden');
            rightBtn.classList.add('hidden');
            return;
        }
        if (currentScroll <= tolerance) leftBtn.classList.add('hidden');
        else leftBtn.classList.remove('hidden');
        if (currentScroll >= maxScroll - tolerance) rightBtn.classList.add('hidden');
        else rightBtn.classList.remove('hidden');
    };
    itemsContainer.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    leftBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        itemsContainer.scrollBy({
            left: -400,
            behavior: 'smooth'
        });
    });
    rightBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        itemsContainer.scrollBy({
            left: 400,
            behavior: 'smooth'
        });
    });
    setTimeout(checkScroll, 300);
}
// Retrieves values, switches to all lowercase to find non-case sensitive match
function $35da740d59af89ba$var$getValue(data, targetKey) {
    if (!data) return undefined;
    if (data[targetKey] !== undefined) return data[targetKey];
    const cleanTarget = targetKey.toLowerCase().trim();
    for(const key in data){
        if (key.toLowerCase().trim() === cleanTarget) return data[key];
    }
    return undefined;
}
// ===== Data Normalisation =====
function $35da740d59af89ba$var$normalizeGameData(docId, data) {
    const getImg = (key)=>{
        const val = $35da740d59af89ba$var$getValue(data, key);
        if (val && typeof val === 'string' && val.includes('http')) return val;
        return $35da740d59af89ba$var$STATIC_IMAGE_FALLBACK_PATH;
    };
    const getBool = (key)=>{
        const val = $35da740d59af89ba$var$getValue(data, key);
        return val === true || String(val).toLowerCase() === 'true';
    };
    // If thumbnail image is missing use logo as backup
    const logoRaw = getImg('Logo Img Src');
    const thumbRaw = getImg('Thumbnail img Src');
    const finalThumb = thumbRaw !== $35da740d59af89ba$var$STATIC_IMAGE_FALLBACK_PATH ? thumbRaw : logoRaw;
    const featuresArr = [];
    if (getBool('New Game')) featuresArr.push('New Game');
    if (getBool('Coming soon')) featuresArr.push('Coming Soon');
    if (getBool('Free spins')) featuresArr.push('Free Spins');
    if (getBool('Buy Bonus')) featuresArr.push('Buy Bonus');
    if (getBool('Fast')) featuresArr.push('Fast Play');
    if (getBool('Tap Tap')) featuresArr.push('Tap to Play');
    if (getBool('Controversy')) featuresArr.push('Controversy');
    if (getBool('Virtuals')) featuresArr.push('Virtuals');
    if (getBool('Low RTP')) featuresArr.push('Low RTP Warning');
    // RTP math - Converts decimals to percentages
    let rtpValue = $35da740d59af89ba$var$getValue(data, 'RTP');
    let rtpString = 'N/A';
    if (rtpValue) {
        const strVal = String(rtpValue);
        if (strVal.includes(':') || strVal.includes(',')) rtpString = strVal;
        else {
            const match = strVal.match(/(\d+\.?\d*)/);
            const number = match ? parseFloat(match[0]) : null;
            if (number !== null) rtpString = number <= 1 ? (number * 100).toFixed(2) + '%' : number.toFixed(2) + '%';
        }
    }
    return {
        id: docId,
        type: 'game',
        name: $35da740d59af89ba$var$getValue(data, 'Name') || "Unknown Title",
        description: $35da740d59af89ba$var$getValue(data, 'Description') || "No description provided.",
        brand: $35da740d59af89ba$var$getValue(data, 'Brand') || "General",
        url: $35da740d59af89ba$var$getValue(data, 'URL') || "#",
        releaseDate: $35da740d59af89ba$var$getValue(data, 'Release Date'),
        logoImgSrc: logoRaw,
        backgroundImgSrc: getImg('Bg Img Src'),
        thumbnailImgSrc: finalThumb,
        rtp: rtpString,
        volatility: $35da740d59af89ba$var$getValue(data, 'Volatility') || 'N/A',
        maxMultiplier: $35da740d59af89ba$var$getValue(data, 'Max Multiplier') || 'N/A',
        reels: $35da740d59af89ba$var$getValue(data, 'Reels') || '',
        rows: $35da740d59af89ba$var$getValue(data, 'Rows') || '',
        isVisible: getBool('Visible'),
        isFeatured: getBool('Featured'),
        isNew: getBool('New Game'),
        features: featuresArr.join(', ') || 'Standard'
    };
}
function $35da740d59af89ba$var$normalizeSlideData(docId, data) {
    const getImg = (key)=>{
        const val = $35da740d59af89ba$var$getValue(data, key);
        if (val && typeof val === 'string' && val.includes('http')) return val;
        return "";
    };
    let img = getImg('Bg Img Src') || getImg('Logo Img Src') || getImg('imgSrc') || getImg('Image');
    return {
        id: docId,
        type: 'slide',
        imgSrc: img
    };
}
// CONTENT FETCHING
// fetchAllContent retrieves images from firestore
async function $35da740d59af89ba$var$fetchAllContent() {
    $35da740d59af89ba$var$FEATURED_LIST = [];
    $35da740d59af89ba$var$GAME_DATA = {};
    try {
        // Run both fetches at the exact same time --> speeds up loading
        const [gamesSnap, slidesSnap] = await Promise.all([
            (0, $ilpIi.getDocs)((0, $ilpIi.collection)($35da740d59af89ba$var$db, "games")),
            (0, $ilpIi.getDocs)((0, $ilpIi.collection)($35da740d59af89ba$var$db, "slides")).catch(()=>({
                    forEach: ()=>{}
                })) // Fail gracefully if no slides
        ]);
        gamesSnap.forEach((doc)=>{
            const game = $35da740d59af89ba$var$normalizeGameData(doc.id, doc.data());
            $35da740d59af89ba$var$GAME_DATA[doc.id] = game;
            if (game.isVisible && game.isFeatured) $35da740d59af89ba$var$FEATURED_LIST.push(game);
        });
        slidesSnap.forEach((doc)=>{
            const slide = $35da740d59af89ba$var$normalizeSlideData(doc.id, doc.data());
            if (slide.imgSrc && slide.imgSrc.length > 20) $35da740d59af89ba$var$FEATURED_LIST.push(slide);
        });
        return true;
    } catch (e) {
        console.error("Critical Firestore Error:", e);
        return false;
    }
}
function $35da740d59af89ba$var$startFeaturedRotator() {
    if ($35da740d59af89ba$var$FEATURED_LIST.length === 0) return;
    let currentIndex = 0;
    const featuredElements = [
        $35da740d59af89ba$var$featuredLogo,
        $35da740d59af89ba$var$featuredDesc,
        $35da740d59af89ba$var$featuredRtp,
        $35da740d59af89ba$var$featuredBtn
    ];
    const updateFeaturedUI = (item)=>{
        if (item.type === 'game') {
            if ($35da740d59af89ba$var$featuredLogo) {
                $35da740d59af89ba$var$featuredLogo.src = item.logoImgSrc;
                $35da740d59af89ba$var$featuredLogo.classList.remove('hidden');
            }
            if ($35da740d59af89ba$var$featuredDesc) {
                $35da740d59af89ba$var$featuredDesc.textContent = item.description;
                $35da740d59af89ba$var$featuredDesc.classList.remove('hidden');
            }
            if ($35da740d59af89ba$var$featuredRtp) {
                $35da740d59af89ba$var$featuredRtp.textContent = item.rtp ? `RTP: ${item.rtp}` : '';
                $35da740d59af89ba$var$featuredRtp.classList.remove('hidden');
            }
            if ($35da740d59af89ba$var$featuredBtn) {
                $35da740d59af89ba$var$featuredBtn.setAttribute('data-game-id', item.id);
                $35da740d59af89ba$var$featuredBtn.classList.remove('hidden');
            }
            if ($35da740d59af89ba$var$featuredContainer) $35da740d59af89ba$var$featuredContainer.classList.remove('slide-active');
        } else {
            featuredElements.forEach((el)=>el?.classList.add('hidden'));
            if ($35da740d59af89ba$var$featuredContainer) $35da740d59af89ba$var$featuredContainer.classList.add('slide-active');
        }
    };
    const renderFeaturedItem = ()=>{
        if (currentIndex >= $35da740d59af89ba$var$FEATURED_LIST.length) currentIndex = 0;
        const item = $35da740d59af89ba$var$FEATURED_LIST[currentIndex];
        const bgUrl = item.type === 'game' ? item.backgroundImgSrc : item.imgSrc;
        if ($35da740d59af89ba$var$featuredBgLayer) $35da740d59af89ba$var$featuredBgLayer.classList.add('fade-out');
        featuredElements.forEach((el)=>{
            if (el) el.style.opacity = '0';
        });
        const bgLoadPromise = new Promise((resolve)=>{
            const img = new Image();
            img.src = bgUrl;
            img.onload = ()=>resolve(bgUrl);
            img.onerror = ()=>resolve(bgUrl);
        });
        Promise.all([
            new Promise((r)=>setTimeout(r, 500)),
            bgLoadPromise
        ]).then(()=>{
            if ($35da740d59af89ba$var$featuredBgLayer) $35da740d59af89ba$var$featuredBgLayer.style.backgroundImage = `url("${bgUrl}")`;
            updateFeaturedUI(item);
            requestAnimationFrame(()=>{
                if ($35da740d59af89ba$var$featuredBgLayer) $35da740d59af89ba$var$featuredBgLayer.classList.remove('fade-out');
                featuredElements.forEach((el)=>{
                    if (el) el.style.opacity = '1';
                });
            });
        });
        currentIndex = (currentIndex + 1) % $35da740d59af89ba$var$FEATURED_LIST.length;
    };
    renderFeaturedItem();
    if ($35da740d59af89ba$var$rotatorInterval) clearInterval($35da740d59af89ba$var$rotatorInterval);
    $35da740d59af89ba$var$rotatorInterval = setInterval(renderFeaturedItem, 8000);
}
async function $35da740d59af89ba$var$loadUiIcons() {
    try {
        const docRef = (0, $ilpIi.doc)($35da740d59af89ba$var$db, "site-settings", "ui_icons");
        const docSnap = await (0, $ilpIi.getDoc)(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            console.log("Firestore Icon Data:", data); // Check your console (F12) to see these!
            // 1. Target the internal <img> tags specifically
            const calImg = document.getElementById("calendar-icon-img");
            if (calImg && data.calendar) calImg.src = data.calendar;
            const filterImg = document.getElementById("filter-icon-img");
            if (filterImg && data.filter) filterImg.src = data.filter;
            // 2. Set Search Icon
            const searchImg = document.getElementById("search-icon");
            if (searchImg && data.search) searchImg.src = data.search;
            // 3. Set Google Logo (for the sign-in button)
            const googleImg = document.getElementById("google-logo-img");
            if (googleImg && data.google_logo) googleImg.src = data.google_logo;
            console.log("UI Icons successfully updated from Firestore");
        } else console.warn("No 'ui_icons' document found in Firestore!");
    } catch (e) {
        console.error("Error loading UI icons:", e);
    }
}
// ===== Calendar rendering =====
function $35da740d59af89ba$var$renderCalendar() {
    const calendarContainer = document.getElementById('calendar-content');
    if (!calendarContainer) return;
    calendarContainer.innerHTML = '';
    const today = new Date();
    const monthsToShow = 3;
    for(let i = 0; i < monthsToShow; i++){
        const currentMonthDate = new Date(today.getFullYear(), today.getMonth() + i, 1);
        const year = currentMonthDate.getFullYear();
        const month = currentMonthDate.getMonth();
        const monthName = currentMonthDate.toLocaleString('default', {
            month: 'long',
            year: 'numeric'
        });
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const startDayIndex = currentMonthDate.getDay();
        const monthSection = document.createElement('div');
        monthSection.className = 'calendar-month-section';
        monthSection.innerHTML = `
            <h2 class="calendar-month-title">${monthName}</h2>
            <div class="calendar-grid-header">
                <div class="weekday-header">Sun</div>
                <div class="weekday-header">Mon</div>
                <div class="weekday-header">Tue</div>
                <div class="weekday-header">Wed</div>
                <div class="weekday-header">Thu</div>
                <div class="weekday-header">Fri</div>
                <div class="weekday-header">Sat</div>
            </div>
            <div class="calendar-month-grid"></div>
        `;
        const grid = monthSection.querySelector('.calendar-month-grid');
        for(let j = 0; j < startDayIndex; j++)grid.innerHTML += `<div class="calendar-day-cell empty"></div>`;
        for(let day = 1; day <= daysInMonth; day++){
            const gamesForDay = Object.values($35da740d59af89ba$var$GAME_DATA).filter((game)=>{
                if (!game.releaseDate || !game.isVisible) return false;
                const gameDate = new Date(game.releaseDate);
                if (isNaN(gameDate.getTime())) return false;
                return gameDate.getDate() === day && gameDate.getMonth() === month && gameDate.getFullYear() === year;
            });
            const cell = document.createElement('div');
            cell.className = 'calendar-day-cell';
            const isToday = day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
            if (isToday) cell.classList.add('today');
            let cellContent = `<span class="day-number">${day}</span>`;
            if (gamesForDay.length > 0) {
                cellContent += `<div class="calendar-split-container">`;
                gamesForDay.forEach((game)=>{
                    cellContent += `
                        <div class="calendar-game-split" 
                             style="background-image: url('${game.thumbnailImgSrc}');"
                             title="${game.name}"
                             data-game-id="${game.id}">
                             <div class="day-overlay"></div>
                        </div>`;
                });
                cellContent += `</div>`;
            }
            cell.innerHTML = cellContent;
            cell.querySelectorAll('.calendar-game-split').forEach((split)=>{
                split.addEventListener('click', $35da740d59af89ba$var$handleThumbnailClick);
            });
            grid.appendChild(cell);
        }
        calendarContainer.appendChild(monthSection);
    }
}
// ===== Dynamic row rendering =====
function $35da740d59af89ba$var$renderDynamicGameRows() {
    const container = document.getElementById('dynamic-rows-container');
    if (!container) return;
    container.innerHTML = '';
    const filtersActive = $35da740d59af89ba$var$currentFilters.brands.length > 0 || $35da740d59af89ba$var$currentFilters.features.length > 0;
    if (filtersActive) {
        const filtered = Object.values($35da740d59af89ba$var$GAME_DATA).filter((game)=>{
            if (!game.isVisible) return false;
            if ($35da740d59af89ba$var$currentFilters.brands.length > 0 && !$35da740d59af89ba$var$currentFilters.brands.includes(game.brand)) return false;
            if ($35da740d59af89ba$var$currentFilters.features.length > 0) for (const req of $35da740d59af89ba$var$currentFilters.features){
                if (!game.features.includes(req)) return false;
            }
            return true;
        });
        $35da740d59af89ba$var$displayFilteredResults(filtered);
    } else {
        if ($35da740d59af89ba$var$searchResultsContainer) $35da740d59af89ba$var$searchResultsContainer.style.display = 'none';
        if ($35da740d59af89ba$var$featuredContainer) $35da740d59af89ba$var$featuredContainer.style.display = 'flex';
        if (container) container.style.display = 'block';
        $35da740d59af89ba$var$renderContinuePlayingRow();
        $35da740d59af89ba$var$ROW_BUCKETS = {};
        const config = [
            {
                title: "New Games",
                field: "isNew"
            },
            {
                title: "Coming Soon",
                field: "isComingSoon"
            },
            {
                title: "Buy Bonus Games",
                field: "hasBuyBonus"
            },
            {
                title: "Free Spins Feature",
                field: "hasFreeSpins"
            },
            {
                title: "Tap Tap Games",
                field: "isTapTap"
            }
        ];
        config.forEach((cfg)=>$35da740d59af89ba$var$ROW_BUCKETS[cfg.title] = []);
        Object.values($35da740d59af89ba$var$GAME_DATA).forEach((game)=>{
            if (!game.isVisible) return;
            config.forEach((cfg)=>{
                if (game[cfg.field]) $35da740d59af89ba$var$ROW_BUCKETS[cfg.title].push(game);
            });
            const brand = game.brand || "Other Games";
            if (!$35da740d59af89ba$var$ROW_BUCKETS[brand]) $35da740d59af89ba$var$ROW_BUCKETS[brand] = [];
            $35da740d59af89ba$var$ROW_BUCKETS[brand].push(game);
        });
        config.forEach((cfg)=>{
            if ($35da740d59af89ba$var$ROW_BUCKETS[cfg.title].length > 0) container.insertAdjacentHTML('beforeend', $35da740d59af89ba$var$buildRowHtml(cfg.title, $35da740d59af89ba$var$ROW_BUCKETS[cfg.title]));
        });
        const special = config.map((x)=>x.title);
        Object.keys($35da740d59af89ba$var$ROW_BUCKETS).filter((k)=>!special.includes(k)).sort().forEach((brand)=>{
            if ($35da740d59af89ba$var$ROW_BUCKETS[brand].length > 0) container.insertAdjacentHTML('beforeend', $35da740d59af89ba$var$buildRowHtml(brand, $35da740d59af89ba$var$ROW_BUCKETS[brand]));
        });
        $35da740d59af89ba$var$attachRowListeners();
    }
}
function $35da740d59af89ba$var$buildRowHtml(title, games) {
    const cards = games.slice(0, 12).map((game)=>`
        <div>
            <a href="#" data-game-id="${game.id}">
                <img src="${game.thumbnailImgSrc}" alt="${game.name}" loading="lazy" 
                     onerror="this.src='${$35da740d59af89ba$var$STATIC_IMAGE_FALLBACK_PATH}'">
            </a>
        </div>
    `).join('');
    return `
        <div class="row">
            <div class="row-header">
                <h2>${title}</h2>
                ${games.length > 12 ? `<button class="view-all-btn" data-category="${title}">View All (${games.length})</button>` : ''}
            </div>
            <div class="row-content-wrapper">
                <button class="scroll-btn left">&lsaquo;</button>
                <div class="row-items">
                    ${cards}
                </div>
                <button class="scroll-btn right">&rsaquo;</button>
            </div>
        </div>`;
}
function $35da740d59af89ba$var$attachRowListeners() {
    document.querySelectorAll('[data-game-id]').forEach((el)=>el.addEventListener('click', $35da740d59af89ba$var$handleThumbnailClick));
    document.querySelectorAll('.row-content-wrapper').forEach((wrapper)=>$35da740d59af89ba$var$setupRowInteractions(wrapper));
    document.querySelectorAll('.view-all-btn').forEach((btn)=>{
        btn.addEventListener('click', (e)=>$35da740d59af89ba$var$openCategoryModal(e.target.getAttribute('data-category')));
    });
}
/* ==========================================================================
   SEARCH & SUGGESTIONS
   ========================================================================== */ function $35da740d59af89ba$var$renderSearchSuggestions(query) {
    const qLower = query.toLowerCase();
    $35da740d59af89ba$var$suggestionsContainer.innerHTML = '';
    if (qLower.length < 2) {
        $35da740d59af89ba$var$suggestionsContainer.style.display = 'none';
        return;
    }
    const filtered = Object.values($35da740d59af89ba$var$GAME_DATA).filter((game)=>{
        if (!game.isVisible) return false;
        return game.name.toLowerCase().includes(qLower) || game.brand.toLowerCase().includes(qLower) || game.features.toLowerCase().includes(qLower);
    }).sort((a, b)=>a.name.localeCompare(b.name)).slice(0, 8);
    if (filtered.length > 0) {
        $35da740d59af89ba$var$suggestionsContainer.innerHTML = filtered.map((game)=>`
            <div class="suggestion-item" data-game-id="${game.id}">
                <img src="${game.thumbnailImgSrc}" alt="${game.name}">
                <div class="suggestion-text">
                    <strong>${game.name}</strong>
                    <span>${game.brand} | ${$35da740d59af89ba$var$RESTRICTED_BRANDS.includes(game.brand) ? 'More Info' : 'Play'}</span>
                </div>
            </div>
        `).join('');
        $35da740d59af89ba$var$suggestionsContainer.style.display = 'flex';
        $35da740d59af89ba$var$suggestionsContainer.querySelectorAll('.suggestion-item').forEach((item)=>{
            item.addEventListener('click', ()=>{
                const id = item.getAttribute('data-game-id');
                $35da740d59af89ba$var$searchInput.value = $35da740d59af89ba$var$GAME_DATA[id].name;
                $35da740d59af89ba$var$suggestionsContainer.style.display = 'none';
                $35da740d59af89ba$var$openGameDetailsModal(id);
            });
        });
    } else $35da740d59af89ba$var$suggestionsContainer.style.display = 'none';
}
function $35da740d59af89ba$var$renderSearchResults(query) {
    const qLower = query.toLowerCase();
    $35da740d59af89ba$var$suggestionsContainer.style.display = 'none';
    if (qLower.length < 2) {
        if ($35da740d59af89ba$var$searchResultsContainer) $35da740d59af89ba$var$searchResultsContainer.style.display = 'none';
        document.getElementById('dynamic-rows-container').style.display = 'block';
        if ($35da740d59af89ba$var$featuredContainer) $35da740d59af89ba$var$featuredContainer.style.display = 'flex';
        $35da740d59af89ba$var$renderContinuePlayingRow();
        return;
    }
    const filtered = Object.values($35da740d59af89ba$var$GAME_DATA).filter((game)=>{
        if (!game.isVisible) return false;
        return game.name.toLowerCase().includes(qLower) || game.brand.toLowerCase().includes(qLower) || game.features.toLowerCase().includes(qLower);
    });
    if ($35da740d59af89ba$var$searchResultsItems) {
        $35da740d59af89ba$var$searchResultsItems.innerHTML = '';
        if (filtered.length > 0) {
            $35da740d59af89ba$var$searchResultsTitle.textContent = `Search Results (${filtered.length}) for "${query}"`;
            $35da740d59af89ba$var$searchResultsItems.innerHTML = filtered.map((game)=>`
                <div><a href="#" data-game-id="${game.id}"><img src="${game.thumbnailImgSrc}" alt="${game.name}"></a></div>
            `).join('');
        } else $35da740d59af89ba$var$searchResultsTitle.textContent = `No results found for "${query}"`;
        $35da740d59af89ba$var$searchResultsContainer.style.display = 'block';
        if ($35da740d59af89ba$var$featuredContainer) $35da740d59af89ba$var$featuredContainer.style.display = 'none';
        document.getElementById('dynamic-rows-container').style.display = 'none';
        document.getElementById('continue-playing-row').style.display = 'none';
        $35da740d59af89ba$var$searchResultsItems.querySelectorAll('a[data-game-id]').forEach((link)=>{
            link.addEventListener('click', $35da740d59af89ba$var$handleThumbnailClick);
        });
    }
}
function $35da740d59af89ba$var$displayFilteredResults(filteredGames) {
    if (!$35da740d59af89ba$var$searchResultsContainer) return;
    document.getElementById('dynamic-rows-container').style.display = 'none';
    if ($35da740d59af89ba$var$featuredContainer) $35da740d59af89ba$var$featuredContainer.style.display = 'none';
    document.getElementById('continue-playing-row').style.display = 'none';
    let titleParts = [];
    if ($35da740d59af89ba$var$currentFilters.brands.length > 0) titleParts.push(`Brands: ${$35da740d59af89ba$var$currentFilters.brands.join(', ')}`);
    if ($35da740d59af89ba$var$currentFilters.features.length > 0) titleParts.push(`Features: ${$35da740d59af89ba$var$currentFilters.features.join(', ')}`);
    let finalTitle = `Filtered Results (${filteredGames.length})`;
    if (titleParts.length > 0) finalTitle += ` - ${titleParts.join(' | ')}`;
    $35da740d59af89ba$var$searchResultsItems.innerHTML = '';
    if (filteredGames.length > 0) {
        $35da740d59af89ba$var$searchResultsTitle.textContent = finalTitle;
        $35da740d59af89ba$var$searchResultsItems.innerHTML = filteredGames.map((game)=>`
            <div><a href="#" data-game-id="${game.id}"><img src="${game.thumbnailImgSrc}" alt="${game.name}"></a></div>
        `).join('');
        $35da740d59af89ba$var$searchResultsItems.querySelectorAll('a[data-game-id]').forEach((link)=>link.addEventListener('click', $35da740d59af89ba$var$handleThumbnailClick));
    } else $35da740d59af89ba$var$searchResultsTitle.textContent = `${finalTitle} (No results found)`;
    $35da740d59af89ba$var$searchResultsContainer.style.display = 'block';
}
/* ==========================================================================
   MODAL LOGIC
   ========================================================================== */ function $35da740d59af89ba$var$handleThumbnailClick(e) {
    e.preventDefault();
    const gameId = e.currentTarget.getAttribute('data-game-id');
    if (gameId) $35da740d59af89ba$var$openGameDetailsModal(gameId);
}
function $35da740d59af89ba$var$openGameDetailsModal(gameId) {
    const game = $35da740d59af89ba$var$GAME_DATA[gameId];
    if (!game) return;
    if ($35da740d59af89ba$var$detailsName) $35da740d59af89ba$var$detailsName.textContent = game.name;
    if ($35da740d59af89ba$var$detailsBg) $35da740d59af89ba$var$detailsBg.style.backgroundImage = `url("${game.backgroundImgSrc}")`;
    if ($35da740d59af89ba$var$detailsLogo) $35da740d59af89ba$var$detailsLogo.src = game.logoImgSrc;
    const restricted = $35da740d59af89ba$var$RESTRICTED_BRANDS.includes(game.brand);
    if ($35da740d59af89ba$var$detailsBtn) {
        $35da740d59af89ba$var$detailsBtn.setAttribute('data-game-id', game.id);
        $35da740d59af89ba$var$detailsBtn.style.display = restricted ? 'none' : 'inline-flex';
    }
    if ($35da740d59af89ba$var$detailsMoreInfoBtn) {
        $35da740d59af89ba$var$detailsMoreInfoBtn.setAttribute('data-game-id', game.id);
        $35da740d59af89ba$var$detailsMoreInfoBtn.href = `more-info.html?id=${gameId}`;
    }
    if ($35da740d59af89ba$var$detailsDesc) $35da740d59af89ba$var$detailsDesc.textContent = game.description;
    if ($35da740d59af89ba$var$detailsRtp) $35da740d59af89ba$var$detailsRtp.textContent = game.rtp;
    if ($35da740d59af89ba$var$detailsBrand) $35da740d59af89ba$var$detailsBrand.textContent = game.brand;
    if ($35da740d59af89ba$var$detailsFeatures) $35da740d59af89ba$var$detailsFeatures.textContent = game.features;
    $35da740d59af89ba$var$detailsModal.classList.add('active');
}
function $35da740d59af89ba$var$openCategoryModal(categoryName) {
    const games = $35da740d59af89ba$var$ROW_BUCKETS[categoryName];
    if (!games) return;
    if ($35da740d59af89ba$var$modalTitle) $35da740d59af89ba$var$modalTitle.textContent = categoryName;
    if ($35da740d59af89ba$var$modalGrid) {
        $35da740d59af89ba$var$modalGrid.innerHTML = games.map((game)=>`
            <div class="modal-grid-item">
                <a href="#" data-game-id="${game.id}">
                    <img src="${game.thumbnailImgSrc}" alt="${game.name}">
                </a>
            </div>
        `).join('');
        $35da740d59af89ba$var$modalGrid.querySelectorAll('a').forEach((link)=>{
            link.addEventListener('click', (e)=>{
                e.preventDefault();
                $35da740d59af89ba$var$categoryModal.classList.remove('active');
                $35da740d59af89ba$var$handleThumbnailClick(e);
            });
        });
    }
    $35da740d59af89ba$var$categoryModal.classList.add('active');
}
// ===== HISTORY & GAME LAUNCH =====
function $35da740d59af89ba$var$launchGame(gameId) {
    const game = $35da740d59af89ba$var$GAME_DATA[gameId];
    if (game) {
        const encodedUrl = encodeURIComponent(game.url);
        window.open(`game-view.html?url=${encodedUrl}&name=${encodeURIComponent(game.name)}`, '_blank');
        $35da740d59af89ba$var$trackGameClick(gameId);
    }
}
async function $35da740d59af89ba$var$trackGameClick(gameId) {
    const user = $35da740d59af89ba$var$auth.currentUser;
    if (!user) return;
    const ref = (0, $ilpIi.doc)($35da740d59af89ba$var$db, 'users', user.uid);
    try {
        // If the game is already in continue playing this makes sure the most recent played is at the front
        await (0, $ilpIi.updateDoc)(ref, {
            gameHistory: (0, $ilpIi.arrayRemove)(gameId)
        });
        await (0, $ilpIi.updateDoc)(ref, {
            gameHistory: (0, $ilpIi.arrayUnion)(gameId)
        });
    } catch (e) {
        try {
            await (0, $ilpIi.setDoc)(ref, {
                gameHistory: [
                    gameId
                ]
            });
        } catch (err) {}
    }
    await $35da740d59af89ba$var$renderContinuePlayingRow();
}
async function $35da740d59af89ba$var$renderContinuePlayingRow() {
    const container = document.getElementById('continue-playing-items');
    const rowParent = document.getElementById("continue-playing-row");
    if (!container || !rowParent) return;
    if ($35da740d59af89ba$var$searchResultsContainer?.style.display === 'block') {
        rowParent.style.display = 'none';
        return;
    }
    container.innerHTML = '';
    let history = [];
    const user = $35da740d59af89ba$var$auth.currentUser;
    if (user) try {
        const snap = await (0, $ilpIi.getDoc)((0, $ilpIi.doc)($35da740d59af89ba$var$db, 'users', user.uid));
        if (snap.exists() && snap.data().gameHistory) history = snap.data().gameHistory.reverse().slice(0, 12);
    } catch (e) {
        console.error("History fetch error:", e);
    }
    const valid = history.filter((id)=>$35da740d59af89ba$var$GAME_DATA[id] && $35da740d59af89ba$var$GAME_DATA[id].isVisible);
    if (valid.length > 0) {
        container.innerHTML = valid.map((id)=>`
            <div>
                <a href="#" data-game-id="${id}">
                    <img src="${$35da740d59af89ba$var$GAME_DATA[id].thumbnailImgSrc}" alt="history">
                </a>
            </div>
        `).join('');
        document.querySelectorAll('#continue-playing-items a').forEach((link)=>{
            link.addEventListener('click', $35da740d59af89ba$var$handleThumbnailClick);
        });
        rowParent.style.display = 'block';
        $35da740d59af89ba$var$setupRowInteractions(rowParent.querySelector('.row-content-wrapper'));
    } else rowParent.style.display = 'none';
}
function $35da740d59af89ba$var$populateFilterSidebar() {
    if (!$35da740d59af89ba$var$brandFiltersContainer || !$35da740d59af89ba$var$featureFiltersContainer) return;
    $35da740d59af89ba$var$brandFiltersContainer.querySelectorAll('.filter-options').forEach((el)=>el.remove());
    $35da740d59af89ba$var$featureFiltersContainer.querySelectorAll('.filter-options').forEach((el)=>el.remove());
    const brandsSet = new Set();
    const featuresSet = new Set();
    Object.values($35da740d59af89ba$var$GAME_DATA).forEach((game)=>{
        brandsSet.add(game.brand);
        if (game.features && game.features !== 'Standard') game.features.split(',').forEach((f)=>featuresSet.add(f.trim()));
    });
    const bHtml = Array.from(brandsSet).sort().map((b)=>`
        <div class="filter-option">
            <input type="checkbox" name="brand" value="${b}">
            <label>${b}</label>
        </div>
    `).join('');
    const fHtml = Array.from(featuresSet).sort().map((f)=>`
        <div class="filter-option">
            <input type="checkbox" name="feature" value="${f}">
            <label>${f}</label>
        </div>
    `).join('');
    $35da740d59af89ba$var$brandFiltersContainer.querySelector('h3').insertAdjacentHTML('afterend', `<div class="filter-options">${bHtml}</div>`);
    $35da740d59af89ba$var$featureFiltersContainer.querySelector('h3').insertAdjacentHTML('afterend', `<div class="filter-options">${fHtml}</div>`);
    if ($35da740d59af89ba$var$filterSidebar) $35da740d59af89ba$var$filterSidebar.querySelectorAll('input[type="checkbox"]').forEach((cb)=>{
        cb.addEventListener('change', ()=>{
            const selectedBrands = [];
            const selectedFeatures = [];
            $35da740d59af89ba$var$filterSidebar.querySelectorAll('input[name="brand"]:checked').forEach((c)=>selectedBrands.push(c.value));
            $35da740d59af89ba$var$filterSidebar.querySelectorAll('input[name="feature"]:checked').forEach((c)=>selectedFeatures.push(c.value));
            $35da740d59af89ba$var$currentFilters = {
                brands: selectedBrands,
                features: selectedFeatures
            };
        });
    });
}
/* ==========================================================================
   INITIALIZATION
   ========================================================================== */ document.addEventListener('DOMContentLoaded', ()=>{
    // 1. Assign static pointers
    $35da740d59af89ba$var$bodyEl = document.body;
    $35da740d59af89ba$var$viewLoggedOut = document.getElementById("logged-out-view");
    $35da740d59af89ba$var$viewLoggedIn = document.getElementById("logged-in-view");
    $35da740d59af89ba$var$emailInputEl = document.getElementById("email-input");
    $35da740d59af89ba$var$passwordInputEl = document.getElementById("password-input");
    const userProfilePictureEl = document.getElementById("user-profile-picture");
    const popupProfilePictureEl = document.getElementById("popup-profile-picture");
    const userEmailDisplayEl = document.getElementById("user-email-display");
    $35da740d59af89ba$var$calendarView = document.getElementById("calendar-view");
    $35da740d59af89ba$var$homeViewContainer = document.getElementById("home-view-container");
    $35da740d59af89ba$var$calendarHomeLink = document.getElementById("calendar-home-link");
    $35da740d59af89ba$var$featuredContainer = document.getElementById("featured-game");
    $35da740d59af89ba$var$featuredBtn = document.getElementById("featured-play-btn");
    $35da740d59af89ba$var$featuredLogo = document.getElementById("featured-logo");
    $35da740d59af89ba$var$featuredDesc = document.getElementById("featured-description");
    $35da740d59af89ba$var$featuredRtp = document.getElementById("featured-rtp");
    $35da740d59af89ba$var$featuredBgLayer = document.getElementById("featured-background");
    $35da740d59af89ba$var$categoryModal = document.getElementById("category-modal");
    $35da740d59af89ba$var$closeCategoryBtn = document.getElementById("close-category-modal");
    $35da740d59af89ba$var$modalTitle = document.getElementById("modal-category-title");
    $35da740d59af89ba$var$modalGrid = document.getElementById("modal-game-grid");
    $35da740d59af89ba$var$detailsModal = document.getElementById("game-details-modal");
    $35da740d59af89ba$var$closeDetailsBtn = document.getElementById("close-details-modal");
    $35da740d59af89ba$var$detailsName = document.getElementById("details-name");
    $35da740d59af89ba$var$detailsBg = document.getElementById("details-background");
    $35da740d59af89ba$var$detailsLogo = document.getElementById("details-logo");
    $35da740d59af89ba$var$detailsBtn = document.getElementById("details-play-btn");
    $35da740d59af89ba$var$detailsDesc = document.getElementById("details-description");
    $35da740d59af89ba$var$detailsRtp = document.getElementById("details-rtp");
    $35da740d59af89ba$var$detailsBrand = document.getElementById("details-brand");
    $35da740d59af89ba$var$detailsFeatures = document.getElementById("details-features");
    // THE CRITICAL BUTTON
    $35da740d59af89ba$var$detailsMoreInfoBtn = document.getElementById("details-more-info-btn");
    $35da740d59af89ba$var$searchInput = document.getElementById("search-input");
    $35da740d59af89ba$var$searchExpandable = document.getElementById("search-menu-item");
    $35da740d59af89ba$var$searchResultsContainer = document.getElementById("search-results-container");
    $35da740d59af89ba$var$searchResultsItems = document.getElementById("search-results-items");
    $35da740d59af89ba$var$searchResultsTitle = document.getElementById("search-results-title");
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) favicon.href = (0, {});
    const googleLogoImg = document.getElementById("google-logo-img");
    if (googleLogoImg) googleLogoImg.src = (0, {});
    const accountArea = document.querySelector('.account-area');
    $35da740d59af89ba$var$suggestionsContainer = document.createElement('div');
    $35da740d59af89ba$var$suggestionsContainer.id = 'search-suggestions';
    $35da740d59af89ba$var$suggestionsContainer.className = 'search-suggestions';
    if (accountArea?.parentNode) accountArea.parentNode.insertBefore($35da740d59af89ba$var$suggestionsContainer, accountArea.nextSibling);
    $35da740d59af89ba$var$filterSidebar = document.getElementById("filter-sidebar");
    $35da740d59af89ba$var$brandFiltersContainer = document.getElementById("brand-filters");
    $35da740d59af89ba$var$featureFiltersContainer = document.getElementById("feature-filters");
    $35da740d59af89ba$var$applyFiltersBtn = document.getElementById("apply-filters-btn");
    $35da740d59af89ba$var$clearFiltersBtn = document.getElementById("clear-filters-btn");
    // 2. Attach Listeners
    document.getElementById("sign-in-with-google-btn")?.addEventListener("click", $35da740d59af89ba$var$authSignInWithGoogle);
    document.getElementById("sign-in-btn")?.addEventListener("click", $35da740d59af89ba$var$authSignInWithEmail);
    document.getElementById("create-account-btn")?.addEventListener("click", $35da740d59af89ba$var$authCreateAccountWithEmail);
    document.getElementById("logout-btn")?.querySelector("button")?.addEventListener("click", $35da740d59af89ba$var$authSignOut);
    const popup = document.getElementById("popup");
    document.getElementById("account-menu-item")?.addEventListener('click', ()=>popup.classList.add("open-popup"));
    document.getElementById("close-popup-btn")?.addEventListener('click', ()=>popup.classList.remove("open-popup"));
    document.getElementById("filter-btn")?.addEventListener('click', ()=>$35da740d59af89ba$var$filterSidebar.classList.add('active'));
    document.getElementById("close-filter-btn")?.addEventListener('click', ()=>$35da740d59af89ba$var$filterSidebar.classList.remove('active'));
    document.getElementById("calendar-btn")?.addEventListener('click', ()=>{
        if ($35da740d59af89ba$var$homeViewContainer) $35da740d59af89ba$var$homeViewContainer.style.display = "none";
        if ($35da740d59af89ba$var$calendarView) $35da740d59af89ba$var$calendarView.style.display = "block";
        if ($35da740d59af89ba$var$searchResultsContainer) $35da740d59af89ba$var$searchResultsContainer.style.display = "none";
    });
    if ($35da740d59af89ba$var$calendarHomeLink) $35da740d59af89ba$var$calendarHomeLink.addEventListener('click', (e)=>{
        e.preventDefault();
        if ($35da740d59af89ba$var$calendarView) $35da740d59af89ba$var$calendarView.style.display = "none";
        if ($35da740d59af89ba$var$homeViewContainer) $35da740d59af89ba$var$homeViewContainer.style.display = "block";
        if ($35da740d59af89ba$var$featuredContainer) $35da740d59af89ba$var$featuredContainer.style.display = "flex";
    });
    if ($35da740d59af89ba$var$featuredBtn) $35da740d59af89ba$var$featuredBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        const id = e.currentTarget.getAttribute('data-game-id');
        if (id) $35da740d59af89ba$var$launchGame(id);
    });
    $35da740d59af89ba$var$closeCategoryBtn?.addEventListener('click', ()=>$35da740d59af89ba$var$categoryModal.classList.remove('active'));
    $35da740d59af89ba$var$closeDetailsBtn?.addEventListener('click', ()=>$35da740d59af89ba$var$detailsModal.classList.remove('active'));
    if ($35da740d59af89ba$var$detailsBtn) $35da740d59af89ba$var$detailsBtn.addEventListener('click', (e)=>{
        const id = e.currentTarget.getAttribute('data-game-id');
        if (id) {
            $35da740d59af89ba$var$detailsModal.classList.remove('active');
            $35da740d59af89ba$var$launchGame(id);
        }
    });
    /* === FIX START: ADD EXPLICIT LISTENER FOR MORE INFO === */ if ($35da740d59af89ba$var$detailsMoreInfoBtn) $35da740d59af89ba$var$detailsMoreInfoBtn.addEventListener('click', (e)=>{
        e.preventDefault(); // Stop default anchor behavior in case href is '#'
        const id = e.currentTarget.getAttribute('data-game-id');
        console.log("More Info Clicked for ID:", id); // DEBUG LOG
        if (id) // Force navigation manually
        window.location.href = `more-info.html?id=${id}`;
        else console.error("No Data-ID found on More Info button");
    });
    /* === FIX END === */ $35da740d59af89ba$var$applyFiltersBtn?.addEventListener('click', ()=>{
        $35da740d59af89ba$var$filterSidebar.classList.remove('active');
        $35da740d59af89ba$var$renderDynamicGameRows();
    });
    $35da740d59af89ba$var$clearFiltersBtn?.addEventListener('click', ()=>{
        $35da740d59af89ba$var$filterSidebar.querySelectorAll('input[type="checkbox"]').forEach((c)=>c.checked = false);
        $35da740d59af89ba$var$currentFilters = {
            brands: [],
            features: []
        };
        $35da740d59af89ba$var$filterSidebar.classList.remove('active');
        $35da740d59af89ba$var$renderDynamicGameRows();
    });
    if ($35da740d59af89ba$var$searchInput && $35da740d59af89ba$var$searchExpandable) {
        $35da740d59af89ba$var$searchInput.addEventListener('focus', ()=>{
            if (window.innerWidth <= 768) $35da740d59af89ba$var$viewLoggedIn.classList.add('search-full-width-mobile');
        });
        $35da740d59af89ba$var$searchInput.addEventListener('blur', ()=>{
            setTimeout(()=>{
                const focus = document.activeElement;
                if ($35da740d59af89ba$var$suggestionsContainer?.contains(focus)) return;
                $35da740d59af89ba$var$suggestionsContainer.style.display = 'none';
                if (window.innerWidth <= 768) $35da740d59af89ba$var$viewLoggedIn.classList.remove('search-full-width-mobile');
                if ($35da740d59af89ba$var$searchInput.value.trim() === '') $35da740d59af89ba$var$renderSearchResults('');
            }, 250);
        });
        $35da740d59af89ba$var$searchInput.addEventListener('input', $35da740d59af89ba$var$debounce(()=>{
            $35da740d59af89ba$var$renderSearchSuggestions($35da740d59af89ba$var$searchInput.value.trim());
        }, 300));
    }
    // 3. Auth Listener
    (0, $6AR8M.onAuthStateChanged)($35da740d59af89ba$var$auth, (user)=>{
        if ($35da740d59af89ba$var$bodyEl.classList.contains('loading-state')) $35da740d59af89ba$var$bodyEl.classList.remove('loading-state');
        const photo = user && user.photoURL ? user.photoURL : $35da740d59af89ba$var$STATIC_IMAGE_FALLBACK_PATH;
        if (user) {
            $35da740d59af89ba$var$showLoggedInView();
            if (userProfilePictureEl) userProfilePictureEl.src = photo;
            if (popupProfilePictureEl) popupProfilePictureEl.src = photo;
            if (userEmailDisplayEl) userEmailDisplayEl.textContent = user.email;
        } else {
            $35da740d59af89ba$var$showLoggedOutView();
            if (userProfilePictureEl) userProfilePictureEl.src = $35da740d59af89ba$var$STATIC_IMAGE_FALLBACK_PATH;
        }
        $35da740d59af89ba$var$renderContinuePlayingRow().then(()=>{
            console.log("User history row refreshed.");
        }).catch((err)=>console.error("History refresh failed:", err));
    });
    // 4. Data Bootstrapper
    (async ()=>{
        const success = await $35da740d59af89ba$var$fetchAllContent();
        if (success) {
            await $35da740d59af89ba$var$loadUiIcons();
            $35da740d59af89ba$var$populateFilterSidebar();
            $35da740d59af89ba$var$renderDynamicGameRows();
            $35da740d59af89ba$var$startFeaturedRotator();
            $35da740d59af89ba$var$renderCalendar();
        }
    })();
});


//# sourceMappingURL=FFLIX.22b33562.js.map
